import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { SwitchToggle } from "../../Components/TableHelper";
import { useFormik } from "formik";

import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";
import ImageUploadDragAndDrop from "../../Components/ImageUploadDragAndDrop";
import { SocialMediaSchema } from "../../Validation/Validation";

const AddSocialMedia = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const [loading, setLoading] = useState(false);
  const editingId = editData?._id;

  const initalvalues = {
    sortOrder: editData?.sortOrder,
    name: editData?.name,
    url: editData?.url,
    icon: editData?.icon,
    isActive: editData?.isActive || true
  }

  const { values, errors, handleChange, handleSubmit, setFieldValue, touched } = useFormik({
    initialValues: initalvalues,
    validationSchema: SocialMediaSchema,
    validateOnChange: false,
    validateOnBlur: true,
    enableReinitialize: true,

    onSubmit: async (values) => {
      setLoading(true)
      try {
        const formData = new FormData();
        formData.append("name", values.name || "");
        formData.append("url", values.url || "");
        formData.append("sortOrder", values.sortOrder || 1);
        formData.append("isActive", values.isActive || false);
        if (values.icon instanceof File) {
          formData.append("icon", values.icon);
        }
        const response = editingId ? await axiosInstance.put(`/socialmedia/updatesocialmedia/${editingId}`, formData) : await axiosInstance.post("/socialmedia/createsocialmedia", formData);
        if (response.status === 200) {
          toast.success(response.data.message)
          navigator("/social-media")
        }

      } catch (error) {
        toast.error(error.response?.data?.message)
        return error
      } finally {
        setLoading(false)
      }
    }
  })

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header">
          <h3 className="page-title">{editingId ? "Update" : "Add"} Social Media</h3>
        </div>
        <div className="col-md-12 grid-margin stretch-card p-0">
          <div className="card">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="exampleInputUsername2" className="col-form-label ">
                        Sort Order
                      </label>
                      <input
                        type="number"
                        className={`border border-dark form-control form-control-sm `}
                        id="sortOrder"
                        name="sortOrder"
                        placeholder="Enter a sort order"
                        value={values.sortOrder}
                        onChange={handleChange}
                      />
                      {touched.sortOrder && errors.sortOrder && (
                        <small className="text-danger">{errors.sortOrder}</small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="exampleInputUsername2" className="col-form-label ">
                        Name
                      </label>
                      <input
                        type="text"
                        className={`border border-dark form-control form-control-sm `}
                        id="name"
                        name="name"
                        placeholder="Enter social media name"
                        value={values.name}
                        onChange={handleChange}
                      />
                      {touched.name && errors.name && (
                        <small className="text-danger">{errors.name}</small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="exampleInputUsername2" className="col-form-label ">
                        Url
                      </label>
                      <input
                        type="text"
                        className={`border border-dark form-control form-control-sm `}
                        id="url"
                        name="url"
                        placeholder="Enter social media url"
                        value={values.url}
                        onChange={handleChange}
                      />
                      {touched.url && errors.url && (
                        <small className="text-danger">{errors.url}</small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <ImageUploadDragAndDrop
                        id="feature-icon"
                        label={`Social Media Image`}
                        value={values.icon}
                        onChange={(file) => setFieldValue("icon", file)}
                        error={errors.icon}
                        touched={touched.icon}
                      />
                    </div>
                  </div>
                  <div className="col-md-12 mt-4" >
                    <SwitchToggle
                      checked={values.isActive}
                      onChange={(val) =>
                        setFieldValue("isActive", val)
                      }
                    />
                  </div>

                </div>
                <div className="text-center mt-4">
                  <Button type="submit" color="primary" disabled={loading}>
                    {loading ? (
                      <span className="d-inline-flex align-items-center gap-2">
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Processing...
                      </span>
                    ) : (
                      "Save"
                    )}
                  </Button>




                  <Link to="/social-media" >
                    <Button color="danger mx-2">Cancel </Button>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddSocialMedia;
